import React from 'react';

type HomeComponentProps = {
  children: JSX.Element;
};

function Home({ children }: HomeComponentProps) {
  return <div className="home__route">{children}</div>;
}

export default Home;
